/** Ordes list by 'id' attribute, ascending (lowest first) */
export function byId(
  a: { id: string | number, [key: string]: any },
  b: { id: string | number, [key: string]: any }
) {
  return a.id < b.id
    ? -1
    : a.id > b.id
      ? 1
      : 0;
}

/** Ordes list by 'id' attribute, descending (highest first) */
export function byIdDescending(
  a: { id: string | number, [key: string]: any },
  b: { id: string | number, [key: string]: any }
) {
  return -byId(a, b);
}

/** Ordes list by 'addTime' attribute, newest first */
export function byLatest(
  a: { addTime: string | number, [key: string]: any },
  b: { addTime: string | number, [key: string]: any }
) {
  return a.addTime < b.addTime
    ? 1
    : a.addTime > b.addTime
      ? -1
      : 0;
}

/** Ordes list by 'addTime' attribute, oldest first */
export function byOldest(
  a: { addTime: string | number, [key: string]: any },
  b: { addTime: string | number, [key: string]: any }
) {
  return - byLatest(a, b);
}

/** Ordes list by 'released' attribute, newest first */
export function byRelease(
  a: { released: string | number, [key: string]: any },
  b: { released: string | number, [key: string]: any }
) {
  return a.released < b.released
    ? 1
    : a.released > b.released
      ? -1
      : 0;
}

/** Ordes list by 'released' attribute, oldest first */
export function byReleaseOldest(
  a: { released: string | number, [key: string]: any },
  b: { released: string | number, [key: string]: any }
) {
  return - byRelease(a, b);
}

/** Orders list by year, month and day, most future first */
export function byDateParts(
  a: { year: number, month: number, day: number, [key: string]: any },
  b: { year: number, month: number, day: number, [key: string]: any }
) {
  return a.year < b.year
    ? 1
    : a.year > b.year
      ? -1
      : a.month < b.month
        ? 1
        : a.month > b.month
          ? -1
          : a.day < b.day
            ? 1
            : a.day > b.day
              ? -1
              : 0;
}

/** Orders list by year, month and day, most historic first */
export function byDatePartsOldest(
  a: { year: number, month: number, day: number, [key: string]: any },
  b: { year: number, month: number, day: number, [key: string]: any }
) {
  return - byDateParts(a, b);
}

/** Orders list by its order property */
export function byOrder(
  a: { order: string | number, [key: string]: any },
  b: { order: string | number, [key: string]: any }
) {
  return +a.order > +b.order
    ? 1
    : +a.order < +b.order
      ? -1
      : 0;
}